export default __webpack_public_path__ + "static/media/designandcode.942f1fab.md";